<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Rotas do PABX</div>

     <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <UseOfRoutesDialog  :rota="rota" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog>

    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="filtredRoutes"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="5" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/rotas/rotas-pabx/criar"
              target="_blank"
              @click="handleGoToNewRota"
            >
              Criar Rota
            </v-btn>
          </v-col>
          <v-col class="mt-5">
          <v-select
            v-model="choicedGroups"
            :items="groupsFiltro"
            multiple
            dense
            label="Grupos"
            @change="filtar"
          >
            <template v-slot:selection="{ item, index }" >
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ choicedGroups.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="choicedGroups.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/rotas/rotas-pabx/copiar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="copyButton(item, $event)"
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copiar Rota</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialog(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Uso</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/rotas/rotas-pabx/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.default">
              <template v-slot:activator="{ on, attrs }">
                <v-btn disabled @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>

            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Rotas: {{ qtdRotas }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import rotasStore from '../_store'
import rotasHttpService from '../_services/rotasHttpService'
import UseOfRoutesDialog from '../_components/UseOfRoutesDialog.vue'

export default {
  components: { ListPagination, UseOfRoutesDialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    form: {
      groups:[]
    },
    choicedGroups: [],
    headers: [
      {
        text: 'Rota',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Grupo',
        value:'group',
        align: 'center'
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        justify: 'center',
        sortable: false,
      },
    ],
    dataRotas: [],
    filtredRoutes: [],
    dataGroups: [],
    rota: {},
    dialog: false,
    groupsFiltro: [],
    itemsMenuExpansible: [],
    intervalRequisitions: null,
    intervalVerifier: false,
  }),

  computed: {
    ...mapGetters('rotasHomeModulePABXStore', ['getRotas', 'getGrupos']),

    todosGruposSelecionados() {
      return this.choicedGroups.length === this.groupsFiltro.length
    },
    algunsGruposSelecionados() {
      return this.choicedGroups.length > 0 && !this.todosGruposSelecionados
    },
    icon() {
      if (this.todosGruposSelecionados) return 'mdi-close-box'
      if (this.algunsGruposSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    numberOfPages() {
      return Math.ceil(this.filtredRoutes.length / this.itemsPerPage)
    },
    qtdRotas() {
      return this.filtredRoutes.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'rotasHomeModulePABXStore', rotasStore)

    await Promise.all([this.listarRotas(), this.listarGruposRotas()])
    
    this.groupsFiltro = this.getGrupos.map(grupo => ({ text: grupo.description, value: grupo.description }))
    this.dataRotas = [...this.getRotas]
    this.dataGroups = [...this.getGrupos]

    this.getGrupos.forEach(grupo => {
      this.dataRotas.forEach(rota => {
        if (rota.group == grupo._id) {
          rota.group = grupo.description
        }
      })
    })

    this.toggle()

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('rotasHomeModulePABXStore', ['listarRotas', 'listarRotaUse', 'listarGruposRotas']),

    handleGoToNewRota(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewRota = this.$router.resolve({ name: 'Rotas/criar' })
        window.open(goToNewRota.href, '_blank')
      } else {
        this.$router.push({ name: 'Rotas/criar' })
      }
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`rotas-pabx/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`rotas-pabx/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`rotas-pabx/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`rotas-pabx/atualizar/${item._id}`)
      }
    },
    copyButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const copyPath = this.$router.resolve(`rotas-pabx/copiar/${item._id}`)
        window.open(copyPath.href, '_blank')
      } else {
        this.$router.push(`rotas-pabx/copiar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover a rota "${item.description}"?`)
      if (resultado) {
        try {
          await rotasHttpService.deleterota(item._id)
          this.filtredRoutes = this.filtredRoutes.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },

    async openDialog(rota) {
      await this.listarRotaUse(rota._id)
      this.rota = rota
      this.dialog = true
    },

    toggle() {
      this.$nextTick(() => {
        if (this.todosGruposSelecionados) {
          this.choicedGroups.splice(0)
        } else {
          this.choicedGroups.splice(0)
          this.choicedGroups = this.groupsFiltro.map(grupo => grupo.value)
        }
        this.filtar()
      })
    },

    filtar() {
      this.filtredRoutes.splice(0, this.filtredRoutes.length)
      this.dataRotas.forEach(rota => {
        if(this.choicedGroups.includes(rota.group)) {
          this.filtredRoutes.push(rota)
        }
      })
    }
  },
}
</script>